import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.scss';

export default function ApexCardContainer({ children, className }) {
  return (
    <div className={classNames('apex-cards', className)}>
      {children}
    </div>
  );
}

ApexCardContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
